const EASTERN_TIME_ZONE = "America/New_York";
const MS_PER_DAY = 24 * 60 * 60 * 1000;

const easternDateParts = new Intl.DateTimeFormat("en-US", {
  timeZone: EASTERN_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit"
});

const partsOf = (formatter, instant) =>
  Object.fromEntries(formatter.formatToParts(instant).map(({ type, value }) => [type, value]));

export const easternToday = () => {
  const { year, month, day } = partsOf(easternDateParts, new Date());
  return `${year}-${month}-${day}`;
};

const utcMidnight = (isoDate) => new Date(`${isoDate}T00:00:00Z`).getTime();

export const daysBetween = (fromIsoDate, toIsoDate) => (utcMidnight(toIsoDate) - utcMidnight(fromIsoDate)) / MS_PER_DAY;

export const shiftDays = (isoDate, days) =>
  new Date(utcMidnight(isoDate) + days * MS_PER_DAY).toISOString().slice(0, 10);

const shortDate = new Intl.DateTimeFormat("en-US", { timeZone: "UTC", month: "short", day: "numeric" });

export const formatShortDate = (isoDate) => shortDate.format(utcMidnight(isoDate));

const easternMinuteParts = new Intl.DateTimeFormat("en-US", {
  timeZone: EASTERN_TIME_ZONE,
  month: "short",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23"
});

export const formatEasternMinute = (isoInstant) => {
  const { month, day, hour, minute } = partsOf(easternMinuteParts, new Date(isoInstant));
  return `${month} ${day}, ${hour}:${minute}`;
};
